import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { breakpointValues } from 'pricing-pages-lib/constants/Breakpoints';
import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { useWindowSize } from '../../hooks/useWindowSize';
import { CommerceFeatures } from '../feature-table/CommerceFeatureTableConfig';
import { CommerceFeatureListItem } from './CommerceFeatureListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceFeaturesList = () => {
  const isMobile = useIsMobile();
  const windowSize = useWindowSize();
  const isLargeScreen = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) && windowSize.width > breakpointValues.sdMac;
  return /*#__PURE__*/_jsx(Grid, {
    marginInline: "0",
    children: CommerceFeatures.map(feature => {
      return /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          md: 6,
          lg: 4
        },
        marginInlineStart: isMobile ? '500' : undefined,
        children: /*#__PURE__*/_jsx(View, {
          paddingInlineStart: isLargeScreen ? '1400' : undefined,
          minBlockSize: isMobile ? '25px' : '50px',
          children: /*#__PURE__*/_jsx(CommerceFeatureListItem, {
            feature: feature
          }, feature.shortName)
        })
      }, feature.shortName);
    })
  });
};